import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import "./sidebar.scss";

import { BiMessageAltEdit } from "react-icons/bi";
import { BsFileEarmarkPost } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";
import { MdDashboard } from "react-icons/md";
import { RiShieldStarFill } from "react-icons/ri";
import { VscGitPullRequestCreate } from "react-icons/vsc";
import logo from "../../../assets/image/TaifurLogo.gif";
import { toggleSwitch } from "../../../feature/navToggle/navSlice";

const Sidebar = () => {
  const toggle = useSelector((state) => state.toggle.toggle);
  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(toggleSwitch());
  };

  return (
    <>
      <div className={toggle ? "port-side-bar asideActive" : "port-side-bar"}>
        <div className="aside__logo">
          <div className="logo__img">
            <Link to="/" onClick={handleToggle}>
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className="logo__text">
            <h2>
              Taifur <span>Islam</span>
            </h2>
          </div>
        </div>
        <div className="aside__main">
          <NavLink
            to="/dashboard"
            end
            className="nav-link"
            onClick={handleToggle}
          >
            <MdDashboard />
            Dashboard
          </NavLink>

          <NavLink
            to="/dashboard/all_posts"
            className="nav-link"
            onClick={handleToggle}
          >
            <BsFileEarmarkPost />
            All Posts
          </NavLink>

          <NavLink
            to="/dashboard/create_post"
            className="nav-link"
            onClick={handleToggle}
          >
            <BiMessageAltEdit />
            Create Post
          </NavLink>
          <NavLink
            to="/dashboard/all_portfolio"
            className="nav-link"
            onClick={handleToggle}
          >
            <RiShieldStarFill />
            All Portfolio
          </NavLink>
          <NavLink
            to="/dashboard/create_portfolio"
            className="nav-link"
            onClick={handleToggle}
          >
            <VscGitPullRequestCreate />
            Create Portfolio
          </NavLink>
          <NavLink
            to="/dashboard/users"
            className="nav-link"
            onClick={handleToggle}
          >
            <FiUsers />
            Users
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
